const ARCHITECTURE_MODELS = [
  'https://w3id.org/rec#Hospital',
  'https://w3id.org/rec#School',
  'https://w3id.org/rec#ShoppingMall',
  'https://w3id.org/rec#Stadium',
  'https://w3id.org/rec#VirtualBuilding',
  'https://w3id.org/rec#BasementLevel',
  'https://w3id.org/rec#MezzanineLevel',
  'https://w3id.org/rec#RoofLevel',
  'https://w3id.org/rec#MailRoom',
  'https://w3id.org/rec#Classroom',
  'https://w3id.org/rec#GroupRoom',
  'https://w3id.org/rec#SmallStudyRoom',
  'https://w3id.org/rec#MainEntrance',
  'https://w3id.org/rec#ServiceEntrance',
  'https://w3id.org/rec#BarRoom',
  'https://w3id.org/rec#CafeteriaRoom',
  'https://w3id.org/rec#CookingRoom',
  'https://w3id.org/rec#DiningRoom',
  'https://w3id.org/rec#DishingRoom',
  'https://w3id.org/rec#Kitchenette',
  'https://w3id.org/rec#Pantry',
  'https://w3id.org/rec#BicycleGarage',
  'https://w3id.org/rec#AdmittingRoom',
  'https://w3id.org/rec#Morgue',
  'https://w3id.org/rec#NeonatalNursingRoom',
  'https://w3id.org/rec#OperatingRoom',
  'https://w3id.org/rec#OutpatientServicesRoom',
  'https://w3id.org/rec#PharmacyRoom',
  'https://w3id.org/rec#RadiologyRoom',
  'https://w3id.org/rec#TherapyRoom',
  'https://w3id.org/rec#LaboratoryDry',
  'https://w3id.org/rec#LaboratoryWet',
  'https://w3id.org/rec#OfficeLandscape',
  'https://w3id.org/rec#OfficeRoom',
  'https://w3id.org/rec#PhoneBooth',
  'https://w3id.org/rec#DisabledToilet',
  'https://w3id.org/rec#Sauna',
  'https://w3id.org/rec#ShowerRoom',
  'https://w3id.org/rec#Toilet',
  'https://w3id.org/rec#FittingRoom',
  'https://w3id.org/rec#ShelterGasLock',
  'https://w3id.org/rec#ShelterRoom',
  'https://w3id.org/rec#TreatmentWaitingRoom',
  'https://w3id.org/rec#TelecommunicationRoom',
  'https://w3id.org/rec#Cabinet',
  'https://w3id.org/rec#CableRoom',
  'https://w3id.org/rec#ClimateControlRoom',
  'https://w3id.org/rec#DataServerRoom',
  'https://w3id.org/rec#ElectricityRoom',
  'https://w3id.org/rec#SprinklerRoom',
  'https://w3id.org/rec#Atrium',
  'https://w3id.org/rec#Auditorium',
  'https://w3id.org/rec#BackOffice',
  'https://w3id.org/rec#Bathroom',
  'https://w3id.org/rec#Bedroom',
  'https://w3id.org/rec#Cinema',
  'https://w3id.org/rec#CleaningRoom',
  'https://w3id.org/rec#CloakRoom',
  'https://w3id.org/rec#ConferenceRoom',
  'https://w3id.org/rec#ConversationRoom',
  'https://w3id.org/rec#CopyingRoom',
  'https://w3id.org/rec#DressingRoom',
  'https://w3id.org/rec#EducationalRoom',
  'https://w3id.org/rec#ElevatorRoom',
  'https://w3id.org/rec#ElevatorShaft',
  'https://w3id.org/rec#Entrance',
  'https://w3id.org/rec#ExerciseRoom',
  'https://w3id.org/rec#ExhibitionRoom',
  'https://w3id.org/rec#FoodHandlingRoom',
  'https://w3id.org/rec#Garage',
  'https://w3id.org/rec#Hallway',
  'https://w3id.org/rec#HealthcareRoom',
  'https://w3id.org/rec#Laboratory',
  'https://w3id.org/rec#LaundryRoom',
  'https://w3id.org/rec#Library',
  'https://w3id.org/rec#LivingRoom',
  'https://w3id.org/rec#LoadingReceivingRoom',
  'https://w3id.org/rec#Lobby',
  'https://w3id.org/rec#LockerRoom',
  'https://w3id.org/rec#Lounge',
  'https://w3id.org/rec#MeditationRoom',
  'https://w3id.org/rec#MothersRoom',
  'https://w3id.org/rec#MultiPurposeRoom',
  'https://w3id.org/rec#Office',
  'https://w3id.org/rec#PersonalHygiene',
  'https://w3id.org/rec#Reception',
  'https://w3id.org/rec#RecordingRoom',
  'https://w3id.org/rec#RecreationalRoom',
  'https://w3id.org/rec#RestingRoom',
  'https://w3id.org/rec#RetailRoom',
  'https://w3id.org/rec#SecurityRoom',
  'https://w3id.org/rec#ServiceShaft',
  'https://w3id.org/rec#Shelter',
  'https://w3id.org/rec#StaffRoom',
  'https://w3id.org/rec#Stairwell',
  'https://w3id.org/rec#Storage',
  'https://w3id.org/rec#TeamRoom',
  'https://w3id.org/rec#Theater',
  'https://w3id.org/rec#TreatmentRoom',
  'https://w3id.org/rec#UtilitiesRoom',
  'https://w3id.org/rec#WasteManagementRoom',
  'https://w3id.org/rec#Workshop',
  'https://w3id.org/rec#AccessControlZone',
  'https://w3id.org/rec#HVACZone',
  'https://w3id.org/rec#OccupancyZone',
  'https://w3id.org/rec#ParkingSpace',
  'https://w3id.org/rec#Workspace',
  'https://w3id.org/rec#Building',
  'https://w3id.org/rec#Level',
  'https://w3id.org/rec#OutdoorSpace',
  'https://w3id.org/rec#Room',
  'https://w3id.org/rec#Site',
  'https://w3id.org/rec#SubBuilding',
  'https://w3id.org/rec#Zone',
  'https://w3id.org/rec#Architecture',
]

export { ARCHITECTURE_MODELS }
